import * as S from "./styles.ts";
import { H6, Image } from "@template/components";

export type CallRate = {
  description: string;
  countryName: string;
  provider: string;
  connectionCost: number;
  flagUrl: string;
  landlineCost?: number;
  mobileCost?: number;
  type?: "Landline" | "Mobile";
  countryIso?: string;
  apiType: "number" | "country";
};

interface ICallResultsProps {
  error?: string;
  results: (CallRate | [])[];
}

const renderPrice = (price: number) => {
  return typeof price === "number" ? `${price.toFixed(1)}p` : "-";
};

export const CallRatesResults = ({ error, results }: ICallResultsProps) => {
  return (
    <S.CallRatesResultsWrapper>
      <S.CallRatesResultsContainer>
        {error && <S.Alert>{error}</S.Alert>}
        {results.map((result, index) => {
          if (Array.isArray(result)) {
            return <S.CallRateSection key={index}></S.CallRateSection>; // Skip empty results
          }
          const type =
            typeof result.landlineCost === "number" ? "Landline" : "Mobile";

          return (
            <S.CallRateSection key={index}>
              <H6>{type}</H6>
              <S.CallRateCard>
                <S.CallRateCardSection>
                  <S.CountrySection>
                    <Image
                      src={`https://yay.com${result.flagUrl}`}
                      alt={result.countryName}
                      height={32}
                      width={32}
                    />
                    {result?.apiType === "number"
                      ? result.description
                      : result.countryName}
                  </S.CountrySection>
                  <S.CallRatePrice $alignStart={true}>
                    {result.provider}
                  </S.CallRatePrice>
                </S.CallRateCardSection>
                <S.CallRateCardSection>
                  <div>Connection</div>
                  <S.CallRatePrice>
                    {renderPrice(result.connectionCost)}
                  </S.CallRatePrice>
                </S.CallRateCardSection>
                <S.CallRateCardSection>
                  <div>Calls</div>
                  <S.CallRatePrice>
                    {renderPrice(
                      type === "Landline"
                        ? result.landlineCost
                        : result.mobileCost
                    )}
                  </S.CallRatePrice>
                </S.CallRateCardSection>
              </S.CallRateCard>
            </S.CallRateSection>
          );
        })}
      </S.CallRatesResultsContainer>
    </S.CallRatesResultsWrapper>
  );
};
